var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 233,
    viewBox: "0 0 93 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1229 232.557H0.987793V226.358H34.1229C44.9346 226.358 53.7306 217.579 53.7306 206.787V26.2124C53.7306 15.4211 44.9346 6.64161 34.1229 6.64161H1.11773V0.442871H34.1229C48.3583 0.442871 59.9411 12.0038 59.9411 26.2124V206.787C59.9411 220.996 48.3583 232.557 34.1229 232.557Z",
    fill: "#017881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M92.4345 116.534L72.2651 104.35V128.714L92.4345 116.534Z",
    fill: "#017881"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.8144 112.409H54.7358V120.657H83.8144V112.409Z",
    fill: "#017881"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group (5).27379b556fd3c0b50059711b748d890e.svg";
export { ForwardRef as ReactComponent };